export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">联系我们</h2>
        <p className="text-foreground-600 text-sm mb-8">有任何问题或建议？欢迎与我们取得联系</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4 mx-auto">
              <i className="ri-mail-line text-xl text-accent-600"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-500">business@xiaoxiaocinema.com</p>
          </div>

          <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl mb-4 mx-auto">
              <i className="ri-question-answer-line text-xl text-primary-500"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
            <p className="text-xs text-foreground-500">content@xiaoxiaocinema.com</p>
          </div>

          <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center bg-secondary-100 rounded-xl mb-4 mx-auto">
              <i className="ri-bug-line text-xl text-secondary-600"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">问题反馈</h3>
            <p className="text-xs text-foreground-500">support@xiaoxiaocinema.com</p>
          </div>
        </div>
      </div>
    </section>
  );
}